import ThemeContext from "components/app/Context";
import SingleSelectFilter from "components/common/SingleSelectFilter";
import Typography from "components/common/Typography";
import MultipleSelectCheckmarks from "components/common/dropdowns/MultiSelect";
import SearchAppBar from "components/common/searchBar";
import { useTranslate } from "hooks/useTranslate";
import { useContext } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { minSearchStrLength } from "utils/CommonConstants";
import {
  converter_ArrayString,
  functionalAreaIdsToNames,
  functionalAreaNamesToIds,
  getBrandOrRegion,
  getCodesByNames,
  getNamesByCodes
} from "utils/CommonFunctions";
import { setFilters, setPayloadData } from "../PlanAssignment.slice";

export default function Filters(props: any) {
  const translate = useTranslate();
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);

  const functionalAreas = useAppSelector((state: any) => state.functionalAreas?.list);
  const filters: any = useAppSelector((state) => state.PlanAssignment.planSelection.filters);
  const propertyList = useAppSelector((state) => state.PlanAssignment.propertyList);
  const { planType } = filters;

  const onMultiSelectChange = (value: any) => {
    const areaDetails = functionalAreaNamesToIds(value);
    dispatch(setFilters({ functionalAreas: areaDetails }));
  };

  const getInputDetails = (input: any) => {
    if (input.length > minSearchStrLength || !input) {
      dispatch(setFilters({ searchText: input }));
    }
  };

  const brandAndRegionMultiselectChange = (input: any, type: string) => {
    const res = getCodesByNames(input, type, propertyList);
    dispatch(setFilters({ [type]: res }));
  };

  const planTypeSelectChange = (val: string) => {
    dispatch(setFilters({ planType: val }));
    dispatch(setPayloadData({ plans: [] }));
    props.setCheckedList([]);
  };

  return (
    <div className="plan_selection-actions">
      <SearchAppBar
        isPreDefinedNav
        value={filters.searchText}
        getInputDetails={getInputDetails}
        sx={{
          border: `1px solid  ${tokens.Border.General.Tertiary}`,
          marginTop: "8px",
          height: "44px",
          width: isMobileScreen ? "none" : "350px"
        }}
      />
      <div className="plan_selection-filters">
        <Typography color={tokens.Text.General.Secondary}>Filter by</Typography>

        <SingleSelectFilter
          label="Plan Type"
          options={converter_ArrayString([translate("common.libraryPlans"), translate("common.templatePlans")], "name")}
          showTextField={false}
          optionKeyName="name"
          onSubmit={(val: any) => planTypeSelectChange(val)}
          selectedOption={filters["planType"]}
        />

        <MultipleSelectCheckmarks
          name="Functional Area"
          label="Functional Area"
          minWidth={"150px"}
          options={functionalAreas}
          initialValues={functionalAreaIdsToNames(filters.functionalAreas)}
          onChange={(value: any) => onMultiSelectChange(value)}
        ></MultipleSelectCheckmarks>

        {!props?.shouldHideTargetingFilters && planType !== translate("common.templatePlans") && (
          <>
            <MultipleSelectCheckmarks
              name="Brand"
              label="Brand"
              options={getBrandOrRegion("brand", propertyList)}
              initialValues={getNamesByCodes(filters?.brand, propertyList)}
              onChange={(value: any) => brandAndRegionMultiselectChange(value, "brand")}
            ></MultipleSelectCheckmarks>
            <MultipleSelectCheckmarks
              name="Region"
              label="Region"
              options={getBrandOrRegion("region", propertyList)}
              initialValues={filters?.region}
              onChange={(value: any) => brandAndRegionMultiselectChange(value, "region")}
            ></MultipleSelectCheckmarks>
          </>
        )}
      </div>
    </div>
  );
}
